import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [accessLoading, setAccessLoading] = useState(false);
  const [canEnter, setCanEnter] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;
    if (!user) { setCanEnter(null); return () => { cancelled = true; }; }
    setAccessLoading(true);
    api.get<{ can_enter_workspace: boolean }>('/api/auth/access-state')
      .then((res) => { if (!cancelled) setCanEnter(res.data.can_enter_workspace); })
      .catch(() => { if (!cancelled) setCanEnter(false); })
      .finally(() => { if (!cancelled) setAccessLoading(false); });
    return () => { cancelled = true; };
  }, [user]);

  if (loading || accessLoading || (user && canEnter === null)) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 12,
          height: '100vh',
        }}
      >
        <Spin size="large" />
        <div style={{ color: '#667085', fontSize: 14 }}>加载中...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (canEnter === false && location.pathname !== '/pending-approval') {
    return <Navigate to="/pending-approval" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
